import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectEntitlementProductMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PRODUCT_MESSAGE);
        this.Id = -1;
        this.Name = null;
        this.Description = null;
        this.Category = null;
        this.CurrencyId = null;
        this.ProPrice = null;
        this.NonProPrice = null;
        this.HasDocument = null;
        this.ImageBytes = null;
        this.ProductDefinitions = null;
        this.IsUnsubscribeAllowed = null;
        this.IsActive = null;
        this.ProductDataType = null;
        this.ShowInSettings = null;
        this.ColorHEX = null;
        this.QuoteDelay = 0;
    }
}
